import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = (props) => {

  const authUser = localStorage.getItem("authUser");
  const filterAuth = JSON.parse(authUser);
  const permissions = filterAuth?.adminDetail?.permissions;
  const authType = filterAuth?.adminDetail?.type;
  let authRoles = localStorage.getItem("adminRole");

  try {
    if (authRoles) {
      authRoles = JSON.parse(authRoles);
    }
  } catch (error) {
    authRoles = [];
  }

  const ref = useRef();

  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("mactive");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("ms-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("ms-active"); // li
          parent3.childNodes[0].classList.add("ms-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("ms-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  const menuItems = [
    { title: "Dashboard", link: "/dashboard", hasArrow: false, allAccess: '', icon: 'mdi mdi-view-dashboard', },
    {
      title: "User Management", link: "/#", hasArrow: true, allAccess: '', icon: 'mdi mdi-account', subMenu: [
        { title: "Users (Shop Owners)", link: "/users" },
        { title: "Manufacturers", link: "/manufacturers" },
        { title: "Delivery-agents", link: "/delivery-agents" }
      ]
    },
    { title: "Banner Management", link: "/banners", hasArrow: false, allAccess: '', icon: 'mdi mdi-city', },
    {
      title: "Category Manage..", link: "/#", hasArrow: true, allAccess: '', icon: 'mdi mdi-map', subMenu: [
        { title: "Category Management", link: "/category-list" },
        { title: "Sub Category", link: "/sub-category-list" },
        { title: "Child Category", link: "/child-category-list" }
      ]
    },
    {
      title: "Block Management", link: "/#", hasArrow: true, allAccess: '', icon: 'mdi mdi-map', subMenu: [
        { title: "Home block", link: "/homeblock-list" },
        { title: "Web Block", link: "/web-block-list" },
        { title: "Search Block", link: "/search-block-list" }
      ]
    },
    {
      title: "Product Management", link: "/productlist", hasArrow: true, allAccess: '', icon: 'fad fa-th',
      subMenu: [
        { title: "Product Management", link: "/productlist" },
      ]
    },

    {
      title: "Role Management", link: "/#", hasArrow: true, allAccess: '', icon: 'fal fa-user',
      subMenu: [
        { title: "Role Management", link: "/roles" },
      ]
    },
    {
      title: "Support Management", link: "/#", hasArrow: true, allAccess: '', icon: 'fal fa-user-headset', subMenu: [
        { title: "Support Categories", link: "/support-category-list" },
        { title: "Support Management", link: "/support-list" }
      ]
    },
    {
      title: "Inquiry Management", link: "/#", hasArrow: true, allAccess: '', icon: 'fas fa-info-circle', subMenu: [
        { title: "Inquiry List", link: "/inquiry-list" },
      ]
    },
    {
      title: "FAQ Management", link: "/#", hasArrow: true, allAccess: '', icon: 'fas solid fa-question',
      subMenu: [
        { title: "FAQ Categories", link: "/faq-management" },
      ]
    },
   
    {
      title: "Order Management", link: "/#", hasArrow: true, allAccess: '', icon: 'fad fa-shopping-cart', subMenu: [
        { title: "Order list", link: "/order-list" },
        { title: "Assign Orders", link: "/assign-orders" },
        { title: "Order Sent to Manufacturer", link: "/order-sent-manufacturer" }
      ]
    },
    {
      title: "Warehouse Manage", link: "/#", hasArrow: true, allAccess: '', icon: 'fad fa-warehouse-alt',
      subMenu: [
        { title: "Warehouse List", link: "/warehouse-list" },
      ]
    },
    {
      title: "Transactions Overview", link: "/#", hasArrow: true, allAccess: '', icon: 'fal fa-file-chart-line',
      subMenu: [
        // { title: "User Transactions", link: "/user-transactions" },
        // { title: "Manufacturer Transactions", link: "/manufacturer-transactions" },
        // { title: "Agent Wallet", link: "/agent-wallet-transactions" },
        { title: "Withdrawal Requests", link: "/withdrawal-request" },
      ]
    },
    {
      title: "Notification Manage", link: "/#", hasArrow: true, allAccess: '', icon: 'fal fa-bell',
      subMenu: [
        { title: "Create Notification", link: "/createNotification" },
        { title: "Notification List", link: "/notifications" },
      ]
    },
    { title: "NewsLetter Management", link: "/newsList", hasArrow: false, allAccess: '', icon: 'fal fa-bells', },

    {
      title: "Setting Management", link: "/#", hasArrow: true, allAccess: '', icon: 'fal fa-bell',
      subMenu: [
        { title: "Admin Setting", link: "/settings" },
        { title: "Instructions Setting", link: "/instructions-setting" },
      ]
    },

  ];

  const checkPermission = (title) => {
    switch (title) {
      case "Dashboard": return permissions?.dashboard || false;
      case "User Management": return permissions?.usermanagement?.allAccess || false;
      case "Banner Management": return permissions?.bannerManagement?.allAccess || false;
      case "Category Manage..": return permissions?.categoryManagement?.allAccess || false;
      case "Block Management": return permissions?.HomeBlockManagement?.allAccess || false;
      case "Product Management": return permissions?.productManagement?.allAccess || false;
      case "Role Management": return false;
      case "Support Management": return permissions?.supportManagement?.allAccess || false;
      case "FAQ Management": return permissions?.faqsManagement?.allAccess || false;
      case "Order Management": return permissions?.orderManagement?.allAccess || false;
      case "Warehouse Manage": return permissions?.warehouseManagement?.allAccess || false;
      default: return false;
    }
  };
  const getFilteredMenuItems = () => {
    return menuItems
      .map(item => ({
        ...item,
        isAllow: checkPermission(item.title)
      }))
      .filter(item => {
        if (authType === "subAdmin") {
          return item.isAllow;
        }
        return true;
      });
  };
  const filteredMenuItems = getFilteredMenuItems();
  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {filteredMenuItems.map((item, index) => (
              <li key={index}>
                <Link to={item.link} className={`menu waves-effect ${!item.hasArrow || 'has-arrow'}`}>
                  <i className={item.icon}></i>
                  <span>{props.t(item.title)}</span>
                </Link>
                {item.subMenu && (
                  <ul className="sub-menu" aria-expanded="true">
                    {item.subMenu.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <Link to={subItem.link} className="waves-effect">
                          <span className="childActive">{props.t(subItem.title)}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
